<!--担保列表-->
<template>
  <div>
    <div class="guarantor_table">
      <el-form ref="form" class="repo-notice-list__search" :inline="true" label-width="90px">
        <el-form-item label="审核状态" label-width="70">
          <el-select v-model="statesValue" placeholder="请选择">
            <el-option v-for="item in labelName" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item >
            <el-button type="primary" @click="factorinList()" class="btnAdd">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table  center :data="loanListData" @row-click="toLoanDetail">
        <el-table-column type='index' label="序号" width="65" align="center">
          <template slot-scope="scope">
            <i v-if="scope.row.signCount||scope.row.payCount > 0"  class="red-point-tip5"></i>
            <span class="item_index">
              {{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="applyCode" label="申请编号" width="110" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productName" label="产品名称" width="100" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column class-name="front-apply-money" label="融资金额" width="115" align="center">
          <template slot-scope="scope">
            <span style="color:#EB662B;">¥{{scope.row.expectTransferAmount | addThousandSign(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column class-name="front-apply-money" label="应收账款转让金额" align="center">
          <template slot-scope="scope">
            <span style="color:#EB662B;">¥{{scope.row.forecastReceAmount | addThousandSign(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bankName" label="收款银行" width="100" :formatter="formatBankName" show-overflow-tooltip></el-table-column>
        <el-table-column prop="applyDate" label="融资申请日期" width="125" align="center" format="yyyy-MM-dd"></el-table-column>
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="scope">
            <span style="position: relative;" @click.stop="slotDialog(scope)" class="business_button">{{scope.row.applyStateName}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="当前业务进度" :visible.sync="stepShow" width="30%" :before-close="handleClose">
        <div class="busineStep">
          <el-steps :active="stepActive" align-center>
            <el-step title="步骤1" description=""></el-step>
            <el-step title="步骤2" description=""></el-step>
            <el-step title="步骤3" description=""></el-step>
            <el-step title="步骤4" description=""></el-step>
            <el-step title="步骤5" description=""></el-step>
          </el-steps>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="stepShow = false">确 定</el-button>
        </span>
      </el-dialog>
      <el-pagination v-if="frontApplyCount > 0"
                     class="step3_pagination"
                     :page-size="pageSize"
                     :total="frontApplyCount"
                     :current-page="pageNum"
                     @current-change="changePage"
                     layout="prev, pager, next"></el-pagination>
    </div>
    <confirm-modal :show="isDeleteLoanItemFrontApply" content="是否确定删除该条借款？" @confirm-click="deleteLoanItem" @cancel-click="isDeleteLoanItemFrontApply = false"></confirm-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import * as types from '../../vuex/types/type';
import _ from 'lodash';
import confirmModal from '../common/Confirm.vue';
import MyLoanApi from '../../api/personalCenter/myloan_bl.js';
export default {
  components: {
    confirmModal
  },
  data() {
    return {
      labelName: [
        {
          label: '全部',
          value: 'all'
        },
        {
          label: '审批中',
          value: 'shz'
        },
        {
          label: '审批通过',
          value: 'shtg'
        },
        {
          label: '审批不通过',
          value: 'shbtg'
        },
        {
          label: '已放款',
          value: 'yfk'
        },
        {
          label: '已结清',
          value: 'yjq'
        }
      ],
      stepActive: 5,
      stepShow: false,
      isDeleteLoanItemFrontApply: false,
      frontApplyId: '',
      loanListData: [],
      frontApplyCount: 0,
      statesValue: 'all', // 筛选数据
      pageNum: 1, // 初始化页码
      pageSize: 8,
    };
  },

  watch: {
    $route() {
      this.factorinList();
    }
  },

  methods: {
    ...mapMutations({
      setActiveName: types.SET_ACTIVE_NAME,
    }),
    ...mapActions({
      getPageCurrent: types.GET_PAGE_CURRENT,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setFailMessage: types.SET_FAIL_MESSAGE
    }),

    formatBankName(obj){
        const bankName = obj.bankName;
        if(bankName.indexOf("-")>0){
          var bankNameArr = bankName.split("-");
          return bankNameArr[0]+"\n("+bankNameArr[1]+")";
        }else{
          return bankName;
        }
    },

    toLoanDetail(row, event, column) {
      if(row.applyState.indexOf("f2")!=-1 || row.applyState.indexOf("f3")!=-1 || row.applyState.indexOf("f4")!=-1){
          const query = {
            frontApplyId: row.frontApplyId,
            isEdit: true,
            yanse: 1,
            productName:row.productName
          };
          switch (row.applyState) {
            case 'f1':
              // 跳转第二步
              this.$router.push({
                path: `/applyLoan/`+row.productId+`/step3_bak_bl`,
                query: {
                  ...query,
                  selectedBankcardId: row.bankAccountIds
                }
              });
              break;
            case 'f2':
              // 跳转第三步
              if(row.isReject == 1){
                this.$router.push({
                  path: `/applyLoan/`+row.productId+`/step2_bl`,
                  query: {
                    ...query,
                    selectedBankcardId: row.bankAccountIds
                  }
                });
              }else{
                this.$router.push({
                  path: `/applyLoan/`+row.productId+`/step3_bl`,
                  query: {
                    ...query,
                    selectedBankcardId: row.bankAccountIds
                  }
                });
              }
              break;
            case 'f3':
              // 跳转第四步
              this.$router.push({
                path: `/applyLoan/`+row.productId+`/step4_bl`,
                query: {
                  ...query,
                  selectedBankcardId: row.bankAccountIds
                }
              });
              break;
            case 'f4':
              // 跳转第五步
              this.$router.push({
                path: `/applyLoan/`+row.productId+`/step5_bl`,
                query
              });
              break;
            default:
              // 跳转第一步
              this.$router.push({
                path: `/applyLoan/`+row.productId+`/step2_bl`,
                query
              });
              break;
          }
      }else{
        this.$router.push({ path: `/guarantorDetail_bl/${row.frontApplyId}` });
      }
    },
    slotDialog(obj) {
      this.stepShow = true
      if(obj.row.applyState == 'f2'){
        this.stepActive = 2;
      }else if(obj.row.applyState == 'f3'){
        this.stepActive = 3;
      }else if(obj.row.applyState == 'f4'){
        this.stepActive = 4;
      }else{
        this.stepActive = 5;
      }
    },
    handleClose() {
      this.stepShow = false
    },

    deleteLoanItem() { // 删除项目
      MyLoanApi.delFrontItem({
        tokenId: localStorage.getItem('dl_tokenId_bl'),
        frontApplyId: this.frontApplyId
      }).then((res) => {
        if (res.rspcode == 1) {
          this.isDeleteLoanItemFrontApply = false;
          this.factorinList();
          this.setSuccessMessage({
            show: true,
            content: '删除成功'
          });
        } else {
          this.setFailMessage({
            show: true,
            content: res.rspdesc || '删除失败'
          });
        }
      }).catch((error) => {

      });
    },

    //      分页调用
    changePage(currentPage) {
      this.pageNum = currentPage;
      this.getPageCurrent({ pageCurrent: currentPage });
      this.factorinList();
    },

    // 获取项目状态列表数据
    factorinList() {
      const _this = this;
      MyLoanApi.getItemApplyList({
        tokenId: localStorage.getItem('dl_tokenId_bl'),
        applyState: _this.statesValue || 'all',
        dataType: 'guarantee',
        pageNum: _this.pageNum,
        pageSize: _this.pageSize
      }).then((res) => {
        if (res.rspcode == 1) {
          _this.loanListData = res.data.frontApplyList;
          _this.frontApplyCount = res.data.frontApplyCount;
          _this.loanListData.forEach((item, index) => {
            const day = this.timestampToTime(item.applyDate);
            item.applyDate = day;
          });
        } else {

        }
      }).catch((error) => {

      });
    },
    // 时间戳转日期
    timestampToTime(value) {
      const time = new Date(value);
      const year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      let h = time.getHours();
      let mm = time.getMinutes();
      if (month <= 9) {
        month = `0${month}`;
      }
      if (day <= 9) {
        day = `0${day}`;
      }
      if (h <= 9) {
        h = `0${h}`;
      }
      if (mm <= 9) {
        mm = `0${mm}`;
      }
      return `${year}-${month}-${day}`;
    },
  },
  created() {
    this.setActiveName('all');
    this.factorinList('all');
  },

};
</script>
<style lang="scss">
.guarantor_table{
  padding-top: 20px;
  .repo-notice-list__search{
    padding-left: 20px;
    box-sizing: border-box;
    margin-bottom: 10px;
    width: 100%;
  }
  .el-table {
    .el-table__row:hover{
      cursor: pointer;
    }
  }
}
.step3_pagination {
  text-align: center;
  padding: 20px 0;
  .active {
    border-bottom: 0;
  }
}
.business_button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  margin: 0 auto;
  margin-right: 8px;
  border-radius: 4px;
  height: 20px;
  text-align: center;
  color: $white;
  font-size: 12px;
  font-weight: normal;
  background: rgb(179, 207, 218);
}
</style>



// WEBPACK FOOTER //
// GuarantorList.vue?dd5e6294